module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (189).4bb9e3e9.jpg";